import React, { useEffect, useState } from 'react';
import { ActivityIndicator, FlatList, ScrollView, View } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../globalComponents/NativeOverrides"
import { event_getEventByEventId, event_getMatchByMatchId, event_getTournamentByTournamentId } from '../../store/actionsv1/events';
import { market_getHedgeByHedgeId, market_processHedge } from '../../store/actionsv1/markets';
import { player_getHelpPromptById } from '../../store/actionsv1/player';
import { PublicPlayerProps } from '../../store/types/auth_svc';
import { HedgedPositionProps, HedgeProps, MarketProps, OrderProps } from '../../store/types/mk_svc';
import { EventProps, MatchProps, TournamentProps } from '../../store/types/sr_svc';
import { market_getOddsLabel } from './helpers/markets';



const HedgeScreen = ({ route, navigation }:any) => {
    const [ loading, setLoading ] = useState(false);

    const dispatch = useDispatch();
    
    const hedges_state:{updated:number, hedges:HedgeProps[], orders:OrderProps[]} = useSelector((state:any) => state.player.hedges, (left, right) => left.updated == right.updated)
    const hedge:HedgeProps | undefined = hedges_state.hedges.find(h => h.hedge_id == route.params.hedge_id)
    const hedge_orders:OrderProps[] = hedges_state.orders
    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
    const market:MarketProps = useSelector((state:any) => state.market.markets.find((m:MarketProps) => m.market_id == hedge?.market_id), (left, right) => left?.market_id == right?.market_id)
    const event:EventProps = useSelector((state:any) => state.event.events[hedge?.event_id??''], (left, right) => left?.time_detail == right?.time_detail)
    const tournament:TournamentProps = useSelector((state:any) => state.event.tournaments[hedge?.event_id??''], (left, right) => left?.tournament_id == right?.tournament_id)
    const match:MatchProps = useSelector((state:any) => state.event.matches[hedge?.event_id??''], (left, right) => left?.match_id == right?.match_id)



    useEffect(() => {
        if(!route.params.hedge_id){ return navigation.goBack() }
        getHedgeFromServer(route.params.hedge_id)
    },[route.params.hedge_id])

    useEffect(() => {
        if(!hedge){ return }
        getEventFromServer()
    },[hedge?.hedge_id])

    const getHedgeFromServer = async(hedge_id:string) => {
        setLoading(true)
        await dispatch(market_getHedgeByHedgeId(hedge_id))
        setLoading(false)
    }

    const getEventFromServer = async() => {
        if(!hedge){ return }
        if(hedge.event_type === 'team' && !event){ dispatch(await event_getEventByEventId(hedge.event_id)) }
        if(hedge.event_type === 'tournament' && !tournament){ dispatch(await event_getTournamentByTournamentId(hedge.event_id)) }
        if(hedge.event_type === 'match' && !match){ dispatch(await event_getMatchByMatchId(hedge.event_id)) }
    }

    const handleProcessHedge = async() => {
        if(player?.type !== 'premium'){ return dispatch(player_getHelpPromptById('t1_hedges')) }
        if(!hedge || loading || !player){ return }//prevent button mashing
        if(hedge.player_id != player.player_id){ return }
        setLoading(true);
        await dispatch(market_processHedge(hedge.hedge_id))
        setLoading(false);
    }

    const renderHedgedPositions = (data: { item:HedgedPositionProps, index: number }) => {
        const order = hedge_orders.find(o => o.positions.map(p => p.position_id.toString()).includes(data.item.position_id.toString()))
        if(!order){ return <></> }
        const position = order.positions.find(p => p.position_id == data.item.position_id)
        if(!position){ return <></> }
        return (
            <View style={{ margin:10, padding:5, borderWidth:1, borderRadius:8, borderColor:Colors.shades.shade600 }}>
                <Text size={18} color={Colors.brand.midnight} weight='bold'>{order.title} ({market_getOddsLabel(position.odds)})</Text>
                <View style={{ padding:10, marginTop:5, flexDirection:'row', justifyContent:'space-between', alignItems:'center' }}>
                    <Text size={14} color={Colors.brand.midnight} weight='regular'>Original Position:</Text>
                    <Text size={14} color={Colors.brand.midnight} weight='semibold'>${data.item.original_stake.toFixed(2)} to win ${data.item.original_potential_winnings.toFixed(2)}</Text>
                </View>
                <View style={{ padding:10, marginTop:5, flexDirection:'row', justifyContent:'space-between', alignItems:'center' }}>
                    <Text size={14} color={Colors.brand.midnight} weight='regular'>New Position:</Text>
                    <Text size={14} color={Colors.brand.midnight} weight='semibold'>${Math.abs(data.item.new_stake).toFixed(2)} to win ${Math.abs(data.item.new_potential_winnings).toFixed(2)}</Text>
                </View>
            </View>
        )
    }

    if(!hedge){
        return (
            <View style={{ padding:20, justifyContent:'center', alignItems:'center' }}>
                <ActivityIndicator size='large' color={Colors.brand.midnight} />
            </View>
        )
    }


    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{ flex:1 }}>
                <View style={{ flex:1, flexDirection:'row', padding:10 }}>
                    <View nativeID='hedged_amt' style={{ flex:1, padding:5, paddingTop:15, paddingBottom:15, margin:5, borderBottomColor:Colors.shades.shade100, borderBottomWidth:1, borderRadius:8, justifyContent:'space-between', backgroundColor:Colors.highlights.highlight400Faded }}>
                        <Text size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>CASH AVAILABLE NOW</Text>
                        <Text style={{ marginTop:5 }} size={28} color={Colors.highlights.highlight400} weight='bold' textAlign='center'>${hedge.cash_rcvd.toFixed(2)}</Text>
                    </View>
                    {hedge.delayed_cash_draw > 0 ?
                    <View nativeID='delayed_cash_draw' style={{ flex:1, padding:5, paddingTop:15, paddingBottom:15, margin:5, borderBottomColor:Colors.shades.shade100, borderBottomWidth:1, borderRadius:8, justifyContent:'space-between', backgroundColor:Colors.highlights.highlight500Faded }}>
                        <Text style={{flex:1}} size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>CASH GIVEN IF SETTLES IN NO-BET</Text>
                        <Text style={{ flex:1, marginTop:5 }} size={28} color={Colors.highlights.highlight400} weight='bold' textAlign='center'>${hedge.delayed_cash_draw.toFixed(2)}</Text>
                    </View>
                    :<></>}
                    {hedge.delayed_cash_no_draw > 0 ?
                    <View nativeID='delayed_cash_draw' style={{ flex:1, padding:5, paddingTop:15, paddingBottom:15, margin:5, borderBottomColor:Colors.shades.shade100, borderBottomWidth:1, borderRadius:8, justifyContent:'space-between', backgroundColor:Colors.highlights.highlight500Faded }}>
                        <Text style={{flex:1}} size={14} color={Colors.brand.midnight} weight='bold' textAlign='center'>CASH GIVEN IF GRADED</Text>
                        <Text style={{ flex:1, marginTop:5 }} size={28} color={Colors.highlights.highlight400} weight='bold' textAlign='center'>${hedge.delayed_cash_no_draw.toFixed(2)}</Text>
                    </View>
                    :<></>}
                </View>
                {hedge && hedge.hedged_positions ?
                <View nativeID='hedged_positions'>
                    <FlatList data={hedge.hedged_positions} renderItem={renderHedgedPositions} keyExtractor={(item) => item.hedged_position_id.toString()} />
                </View>
                :<></>}
            </ScrollView>
            {hedge.status === 'pending' ?
            <TouchableOpacity nativeID='delayed_cash' style={{ padding:10, backgroundColor:Colors.shades.shade100, margin:10, borderRadius:8 }} onPress={() => window.open('https://support.bettoredge.com/hc/en-us/articles/9683385953047-What-are-hedged-positions', '_blank')}>
                <Text size={18} weight='semibold' color={Colors.utility.warning} textAlign='center' style={{ margin:5 }}>NOTICE</Text>
                {hedge.delayed_cash_draw > 0 ?
                <Text size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>Cash out inludes a 0.0% fee. Also, some funds will be held until the positions are graded. An additional amount of <Text size={14} color={Colors.highlights.highlight400} weight='bold'>${hedge.delayed_cash_draw.toFixed(2)}</Text> will be released if the impacted positions are graded as a NO-BET / DRAW.</Text>
                :<></>}
                {hedge.delayed_cash_no_draw > 0 ?
                <Text size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>Cash out inludes a 0.0% fee. Also, some funds will be held until the positions are graded. An additional amount of <Text size={14} color={Colors.highlights.highlight400} weight='bold'>${hedge.delayed_cash_no_draw.toFixed(2)}</Text> will be released if the impacted positions DO NOT result in a no bet.</Text>
                :<></>}
                {hedge.delayed_cash_draw == 0 && hedge.delayed_cash_no_draw == 0 ?
                <Text size={14} color={Colors.brand.midnight} weight='regular' textAlign='center'>Cash out inludes a 0.0% fee.</Text>
                :<></>}
            </TouchableOpacity>
            :<></>}
            {hedge.player_id == player?.player_id && hedge.status === 'pending' ?      
            <TouchableOpacity style={{ margin: 10, borderRadius:100, backgroundColor:player?.type != 'premium' ? Colors.incentive.gold : Colors.highlights.highlight400, padding:10, justifyContent:'center', alignItems:'center' }} onPress={() => handleProcessHedge()}>
                {loading ?
                <ActivityIndicator size='small' color={Colors.shades.white}/>
                :
                <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center' }}>
                    <Text size={14} color={Colors.shades.white} textAlign='center' weight='semibold'>CASH OUT</Text>
                    {player?.type != 'premium' ?
                    <Icon containerStyle={{marginLeft: 5}} type='feather' name='lock' size={18} color={Colors.shades.white} />
                    :<></>}
                </View>
                }
            </TouchableOpacity>
            :<></>}
            {hedge.status !== 'pending' ?      
            <View style={{ margin: 10, borderRadius:100, backgroundColor:Colors.brand.slate, padding:10 }}>
                <Text size={14} color={Colors.shades.white} textAlign='center' weight='semibold'>{hedge.status.toUpperCase()}</Text>
            </View>
            :<></>}
        </View>
    )
}

export default HedgeScreen